import { createApp } from 'vue'

import App from './App.vue'
import { describeError, logger } from '@/lib/log'

const app = createApp(App)

app.config.errorHandler = (error, _instance, info) => {
  logger.error(`Unhandled Vue error (${info}): ${describeError(error)}`, error)
}

window.addEventListener('unhandledrejection', (event) => {
  logger.error(`Unhandled rejection: ${describeError(event.reason)}`)
})

app.mount('#app')
